import "./App.scss";
import Swal from "sweetalert2";
import { useEffect } from "react";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import NotFound from "./Pages/NotFoundpage";
import MailVerify from "./Pages/MailVerifyPage";
import Sidebar from "./Container/Sidebar/Sidebar";
import MobileTopBar from "./Container/MobileShell/MobileTopBar";
import MobileBottomNav from "./Container/MobileShell/MobileBottomNav";
import ForgotPassword from "./Pages/ForgotPassword";
import { RouterItems } from "./ProtectedRoutes/RouterItems";
import ProtectedRoute from "./ProtectedRoutes/ProtectedRoute";
import { useGlobalContext } from "./ContextApi/GlobalContext";
import { getCompanyDetails } from "./Backend/profileFunction";
import { getDashboardData } from "./Backend/dashboardfunction";
import { removeAuthorization } from "./Functions/AuthFunction";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

function AppContent() {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobalContext();

  const logoutHandler = () => {
    removeAuthorization();
    // Clear all auth & data states
    dispatch({ authToken: false, companyData: false, dashboardData: false });
    navigate("/login");
  };

  const handleSubscriptionExpiryCheck = async (expiresAt) => {
    // Ensure we have a date and check if it is in the past
    if (expiresAt && new Date(expiresAt) < new Date()) {
      await Swal.fire({
        icon: "error",
        title: "Plan Expired",
        text: "Your subscription has expired. All active forms have been paused.",
        confirmButtonText: "Renew Now",
        confirmButtonColor: "#0B1C2D",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        // Redirect strictly after clicking the button
        if (result.isConfirmed) {
          navigate("/plans");
        }
      });
    }
  };

  const getDatas = async () => {
    // 1. Fetch Company Details (acts as auth check)
    const companyRes = await getCompanyDetails();

    if (companyRes?.success) {
      // A. Update Company Data
      dispatch({ companyData: companyRes?.data });

      // B. Fetch Dashboard Data immediately
      const dashboardRes = await getDashboardData();
      if (dashboardRes?.success) {
        // C. Store Dashboard Data in Global State
        dispatch({ dashboardData: dashboardRes.data });
      }
      // C. Check Subscription Expiry
      await handleSubscriptionExpiryCheck(
        companyRes?.data?.subscription?.expiresAt,
      );
      // D. Check Subscription Status
    } else if (companyRes?.error === "Unauthorized: Invalid Token.") {
      // Handle Session Expiry
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your security token has expired. Please login again to continue.",
        confirmButtonText: "Login",
        confirmButtonColor: "#0B1C2D",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result?.isConfirmed) {
          logoutHandler();
        }
      });
    }
  };

  useEffect(() => {
    // Trigger data fetch if logged in
    if (state?.authToken) {
      getDatas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.authToken]);

  return (
    <>
      {state?.authToken && (
        <>
          <MobileTopBar />
          <Sidebar />
          <MobileBottomNav />
        </>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<MailVerify />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {RouterItems?.map((route, index) => (
            <Route key={index} path={route?.link} element={route?.page} />
          ))}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
